// Cliente API minimalista para el widget. Solo fetch + types.

export interface AssistantAction {
  type: string;
  [k: string]: any;
}

export interface ChatResponse {
  message: string;
  conversationId: string;
  intent?: string;
  riskLevel?: string;
  actions?: AssistantAction[];
  citedSources?: Array<{ title: string; url?: string; sourceType: string }>;
}

export interface PublicConfig {
  businessId: string;
  slug: string;
  name: string;
  primaryColor: string;
  assistantName: string;
  welcomeMessage: string;
  disclaimerText: string;
  rgpdConsentText: string;
  privacyPolicyUrl?: string;
  appointmentEnabled: boolean;
  leadCaptureEnabled: boolean;
  quickReplies: string[];
  emergencyMessage: string;
}

export class ApiClient {
  constructor(private baseUrl: string, private businessSlug: string) {}

  async getConfig(): Promise<PublicConfig> {
    const r = await fetch(`${this.baseUrl}/api/business/${encodeURIComponent(this.businessSlug)}/config`);
    if (!r.ok) throw new Error(`Config error ${r.status}`);
    return r.json();
  }

  async startConversation(visitorId: string | undefined, sourceUrl: string): Promise<{ conversationId: string; visitorId: string; welcomeMessage?: string; quickReplies?: string[] }> {
    const r = await fetch(`${this.baseUrl}/api/chat/start`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        businessSlug: this.businessSlug,
        visitorId,
        sourceUrl,
        userAgent: navigator.userAgent,
      }),
    });
    if (!r.ok) throw new Error(`Start error ${r.status}`);
    return r.json();
  }

  async sendMessage(conversationId: string, message: string): Promise<ChatResponse> {
    const r = await fetch(`${this.baseUrl}/api/chat/message`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ conversationId, message, _hp: '' }),
    });
    if (!r.ok) {
      const text = await r.text();
      throw new Error(`Message error ${r.status}: ${text}`);
    }
    return r.json();
  }

  async submitChatForm(payload: {
    conversationId: string;
    name: string;
    email: string;
    phone?: string;
    topic?: string;
    consentAccepted: true;
    appointmentTypeSlug?: string;
    appointmentStartsAt?: string;
  }): Promise<{ message: string; conversationId: string; lead: { id: string }; appointment?: any }> {
    const r = await fetch(`${this.baseUrl}/api/chat/form`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ ...payload, _hp: '' }),
    });
    if (!r.ok) {
      const text = await r.text();
      throw new Error(`Form error ${r.status}: ${text}`);
    }
    return r.json();
  }
}
